import { render } from "./IOT.vue?vue&type=template&id=6e5dd01f"
import script from "./IOT.vue?vue&type=script&lang=js"
export * from "./IOT.vue?vue&type=script&lang=js"
script.render = render

export default script